<ng-container *ngIf="show$ | async">
    <mat-progress-bar
        [mode]="(mode$ | async) ?? 'indeterminate'"
        [value]="(progress$ | async) ?? 0">
    </mat-progress-bar>
</ng-container>
